import React from 'react'
import { MdVisibility } from "react-icons/md"
import { useHistory } from 'react-router'
export const OnlinePaymentRegisterList = () => {
    const history = useHistory()
    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-start mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                        </div>
                        {/* <div className="d-flex justify-content-end mb-3">
                            <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('add-quotes')}
                            >Add Quotes
                            </button>
                        </div> */}

                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Id</th>
                                        <th>Gateway</th>
                                        <th>Customer</th>
                                        <th>Date of Receipt</th>
                                        <th>Receipt Ref</th>
                                        <th>Gateway Ref</th>
                                        <th>Amount</th>
                                        <th>Payment Type</th>
                                        <th>Booking Ref#</th>
                                        <th>Invoice Ref#</th>
                                        <th>Status</th>
                                        <th>Post to FA</th>
                                        <th>Action</th>

                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >1</td>
                                        <td>Telr Gateway</td>
                                        <td>Lorem Ipsum</td>
                                        <td>20 July, 2021</td>
                                        <td>#51521326</td>
                                        <td>S20PAY14APR202165252</td>
                                        <td>AED 6598.00</td>
                                        <td>Advance</td>
                                        <td>#25652652632</td>
                                        <td>#25652652632</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Successful</span> </td>
                                        <td><h6 className="bg-warning text-center p-1 rounded text-dark">Pending</h6></td>
                                        <td><MdVisibility
                                            className="pointer"
                                            onClick={() => history.push('online-payment-register-detail')}
                                            color="#0323fe"
                                            size="25px"
                                        /></td>
                                    </tr>


                                    <tr>
                                        <td 
                                        // scope="row"
                                        >1</td>
                                        <td>Telr Gateway</td>
                                        <td>Lorem Ipsum</td>
                                        <td>20 July, 2021</td>
                                        <td>#51521326</td>
                                        <td>S20PAY14APR202165252</td>
                                        <td>AED 6598.00</td>
                                        <td>Advance</td>
                                        <td>#25652652632</td>
                                        <td>#25652652632</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-soft-danger">Unsuccessful</span> </td>
                                        <td><h6 className="bg-warning text-center p-1 rounded text-dark">Pending</h6></td>
                                        <td><MdVisibility
                                            className="pointer"
                                            onClick={() => history.push('online-payment-register-detail')}
                                            color="#0323fe"
                                            size="25px"
                                        /></td>
                                    </tr>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >1</td>
                                        <td>Telr Gateway</td>
                                        <td>Lorem Ipsum</td>
                                        <td>20 July, 2021</td>
                                        <td>#51521326</td>
                                        <td>S20PAY14APR202165252</td>
                                        <td>AED 6598.00</td>
                                        <td>Advance</td>
                                        <td>#25652652632</td>
                                        <td>#25652652632</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Successful</span> </td>
                                        <td><h6 className="bg-warning text-center p-1 rounded text-dark">Pending</h6></td>
                                        <td><MdVisibility
                                            className="pointer"
                                            onClick={() => history.push('online-payment-register-detail')}
                                            color="#0323fe"
                                            size="25px"
                                        /></td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
